import React from 'react';
import { useRouter } from 'next/router';

import CardListContainer from '@/components/Rank/SoloRank/Card/CardListContainer';
import TableTemplate from '@/components/Common/Table/TableTemplate';
import TableRow from '@/components/Common/Table/TableRow';
import RankTableBody from '@/components/Rank/SoloRank/RankTableBody';
import TableCount from '@/components/Common/Table/TableCount';
import TablePagination from '@/components/Common/Table/TablePagination';

import {
  FooterButtonLayout,
  NoHistory,
} from '@/components/Common/Table/Table.styled';

function SoloRank({ ranks }: any) {
  const router = useRouter();
  const { query } = router;

  const { to, total, current_page, per_page, from } =
    ranks.isSuccess && ranks.data.data.rank;

  const rankList = ranks.isSuccess && ranks.data.data.rank.data;
  const rankListFirstPage =
    ranks.isSuccess &&
    ranks.data.data.rank.data.filter((x: any, index: any) => {
      return index > 4;
    });

  if (ranks.isError || ranks.isLoading)
    return <NoHistory>조회된 내역이 없습니다.</NoHistory>;

  return (
    <div>
      {!ranks.isLoading && (
        <>
          {current_page === 1 && <CardListContainer data={rankList} />}
          <TableTemplate
            colgroup={COLGROUP}
            Column={<TableRow columns={TABLE_HEADER} />}
            Body={
              <RankTableBody
                  from={current_page === 1 ? from + 5 : from}
                  data={current_page === 1 ? rankListFirstPage : rankList}
              />
            }
            Footer={
              <>
                <FooterButtonLayout>
                  <TableCount totalCount={total} presentCount={to} />
                </FooterButtonLayout>
                <TablePagination
                  page={current_page}
                  perPage={per_page}
                  count={total}
                  query={query}
                  redirectPath="/records/rank"
                />
              </>
            }
          />
        </>
      )}
    </div>
  );
}

export default SoloRank;

const TABLE_HEADER = [
  '순위',
  '소환사명',
  '티어',
  'LV',
  'LP',
  '승률',
  '승',
  '패',
];

const COLGROUP = [
  { id: 1, col: '10%' },
  { id: 2, col: '10%' },
  { id: 3, col: '10%' },
  { id: 4, col: '10%' },
  { id: 5, col: '10%' },
  { id: 6, col: '10%' },
  { id: 7, col: '10%' },
  { id: 8, col: '10%' },
];
